import { queryOptions } from "@tanstack/react-query";

import { sortUsersByDisplayName } from "../../lib";
import { tasksApi } from "../../lib/api";

/** Eligible-assignee pool changes only when an admin edits roles/case access, so it can stay warm far longer than the default. */
const TASK_ASSIGNEES_STALE_TIME = 30 * 60 * 1000;

export const taskAssigneesQueryKey = ["tasks", "assignees"] as const;

const loadTaskAssignees = async (caseId?: string) => {
  const assignees = await tasksApi.listAssignees(caseId);

  return { ...assignees, users: sortUsersByDisplayName(assignees.users) };
};

export const taskAssigneesQueryOptions = queryOptions({
  queryKey: taskAssigneesQueryKey,
  queryFn: () => loadTaskAssignees(),
  staleTime: TASK_ASSIGNEES_STALE_TIME,
});

export const caseTaskAssigneesQueryOptions = (caseId: string) =>
  queryOptions({
    queryKey: [...taskAssigneesQueryKey, caseId],
    queryFn: () => loadTaskAssignees(caseId),
    staleTime: TASK_ASSIGNEES_STALE_TIME,
  });
